/* ==========================================================================
   C13 HEALTH — cart drawer
   Refreshes itself through the Section Rendering API so the Liquid in
   sections/c13-cart-drawer.liquid stays the only definition of the markup.
   ========================================================================== */
(function () {
  'use strict';

  var SECTION = 'c13-cart-drawer';
  var SELECTOR = '[data-c13-drawer="cart"]';

  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  function drawer() { return $(SELECTOR); }

  function money(cents) {
    var f = (window.C13 && window.C13.moneyFormat) || '£{{amount}}';
    var v = (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return f.replace(/\{\{\s*amount[^}]*\}\}/, v);
  }

  function syncCount(cart) {
    $$('[data-c13-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
      el.classList.toggle('is-visible', cart.item_count > 0);
    });
  }

  /* ---- replace the drawer markup, keeping it open if it already was ---- */
  function refresh(reopen) {
    var current = drawer();
    var wasOpen = current && current.classList.contains('is-open');

    return fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root + '?sections=' + SECTION
      : '/?sections=' + SECTION)
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data[SECTION];
        if (!html || !current) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        var next = tmp.querySelector(SELECTOR);
        if (!next) return;
        if (wasOpen || reopen) next.classList.add('is-open');
        current.parentNode.replaceChild(next, current);
        if (window.C13 && window.C13.initDrawers) window.C13.initDrawers();
        if (wasOpen || reopen) {
          next.setAttribute('aria-hidden', 'false');
          if (!wasOpen && window.C13 && window.C13.lockScroll) window.C13.lockScroll(true);
        }
      })
      .catch(function () { /* the page will still be correct after a reload */ });
  }

  function open() {
    var d = drawer();
    if (!d) { window.location.href = '/cart'; return; }
    var opener = $('[data-c13-drawer-open="cart"]');
    if (opener) { opener.click(); return; }
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    if (window.C13 && window.C13.lockScroll) window.C13.lockScroll(true);
  }

  /* ---- line changes ---- */
  var busy = false;
  function change(key, quantity) {
    if (busy) return;
    busy = true;
    var d = drawer();
    if (d) d.classList.add('is-busy');

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        syncCount(cart);
        var sub = $('[data-c13-cart-subtotal]', drawer());
        if (sub) sub.textContent = money(cart.total_price);
        document.dispatchEvent(new CustomEvent('c13:cart:updated', { detail: { cart: cart } }));
        return refresh(false);
      })
      .catch(function () {
        if (window.C13 && window.C13.toast) window.C13.toast('Could not update your bag');
      })
      .finally(function () {
        busy = false;
        var dd = drawer();
        if (dd) dd.classList.remove('is-busy');
      });
  }

  /* ---- delegated events (the drawer node is replaced on every refresh) ---- */
  document.addEventListener('click', function (e) {
    var openBtn = e.target.closest('[data-c13-cart-open]');
    if (openBtn) {
      if (!drawer()) return;               /* no drawer: let the link go to /cart */
      e.preventDefault();
      open();
      return;
    }

    var host = e.target.closest(SELECTOR);
    if (!host) return;

    var remove = e.target.closest('[data-c13-cart-remove]');
    if (remove) {
      e.preventDefault();
      change(remove.getAttribute('data-c13-cart-remove'), 0);
      return;
    }

    var down = e.target.closest('[data-c13-qty-down]');
    var up = e.target.closest('[data-c13-qty-up]');
    if (down || up) {
      e.preventDefault();
      var wrap = (down || up).closest('[data-c13-qty]');
      var input = $('input', wrap);
      if (!input) return;
      var next = Math.max(0, (parseInt(input.value, 10) || 0) + (up ? 1 : -1));
      input.value = next;
      change(input.getAttribute('data-c13-cart-qty'), next);
    }
  });

  document.addEventListener('change', function (e) {
    var input = e.target.closest('[data-c13-cart-qty]');
    if (!input || !e.target.closest(SELECTOR)) return;
    change(input.getAttribute('data-c13-cart-qty'), Math.max(0, parseInt(input.value, 10) || 0));
  });

  /* ---- open on add to cart ---- */
  document.addEventListener('c13:cart:change', function (e) {
    if (e.detail && e.detail.cart) syncCount(e.detail.cart);
    refresh(true);
  });

  window.C13 = window.C13 || {};
  window.C13.cartDrawer = { open: open, refresh: refresh };
})();
